var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.backupLogsShow
    ? _c("div", { staticClass: "popup" }, [
        _c("div", { staticClass: "content", attrs: { id: "viewBackupLogs" } }, [
          _c("div", { staticClass: "title" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("language.popup.taskListPopup.viewLogs")))
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "icon white-close dialog-close",
              on: {
                click: function($event) {
                  return _vm.closePage()
                }
              }
            })
          ]),
          _vm._v(" "),
          _vm.loading
            ? _c("div", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading"
                  }
                ],
                staticClass: "backupBody"
              })
            : _c("div", { staticClass: "backupBody" }, [
                !_vm.nonFlag
                  ? _c("span", [
                      _c("div"),
                      _vm._v(" "),
                      _vm.viewDetail &&
                      _vm.viewDetail.tasks[0] &&
                      (_vm.viewDetail.tasks[0].tranferWay == "backup" ||
                        _vm.viewDetail.tasks[0].tranferWay == "retry-backup")
                        ? _c("div", { staticClass: "sync_detail" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("language.cloudBackup.backupDetails")
                              )
                            )
                          ])
                        : _c("div", { staticClass: "sync_detail" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("language.cloudBackup.restoreDetails")
                              )
                            )
                          ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { class: _vm.toItemExist ? "catalog" : "not-catalog" },
                        [
                          _vm.viewDetail.tasks[0].tranferWay == "backup" ||
                          _vm.viewDetail.tasks[0].tranferWay == "retry-backup"
                            ? _c("div", { staticClass: "log-line" }, [
                                _c("div", { staticClass: "detail_txt" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("language.cloudBackup.backup")
                                      ) +
                                      ": "
                                  )
                                ]),
                                _vm._v(" "),
                                !_vm.viewDetail.tasks[0].fromItem.data
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "backup-category-link",
                                        staticStyle: {
                                          lineHeight: "18Px",
                                          float: "left"
                                        },
                                        attrs: {
                                          title: _vm._f("getCatalogTitle")(
                                            _vm._f("getCatalog")(
                                              _vm.viewDetail.tasks[0].fromItem
                                                .nodes
                                            )
                                          )
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.toSourceCatalog(
                                              _vm.viewDetail.tasks[0].fromItem
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                       " +
                                            _vm._s(
                                              _vm._f("getCatalog")(
                                                _vm.viewDetail.tasks[0].fromItem
                                                  .nodes
                                              )
                                            ) +
                                            "\n                   "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.viewDetail.tasks[0].fromItem.data
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "backup-category-link",
                                        staticStyle: {
                                          lineHeight: "18Px",
                                          float: "left"
                                        },
                                        attrs: {
                                          title: _vm._f("getBackupInfo")(
                                            _vm._f("getCatalog")(
                                              _vm.viewDetail.tasks[0].fromItem
                                                .data[0].nodes
                                            )
                                          )
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.openSource(
                                              _vm.viewDetail.tasks[0].fromItem
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                       " +
                                            _vm._s(
                                              _vm._f("getBackupInfo")(
                                                _vm._f("getCatalog")(
                                                  _vm.viewDetail.tasks[0]
                                                    .fromItem.data[0].nodes
                                                )
                                              )
                                            ) +
                                            " \n                   "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            : _c("div", { staticClass: "log-line" }, [
                                _c("div", { staticClass: "detail_txt" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("language.cloudBackup.restore")
                                      ) +
                                      ": "
                                  )
                                ]),
                                _vm._v(" "),
                                !_vm.viewDetail.tasks[0].toItem.data
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "backup-category-link",
                                        staticStyle: {
                                          lineHeight: "18Px",
                                          float: "left"
                                        },
                                        attrs: {
                                          title: _vm._f("getCatalog")(
                                            _vm.viewDetail.tasks[0].toItem.nodes
                                          )
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.toRestoreSource(
                                              _vm.viewDetail.tasks[0]
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                             " +
                                            _vm._s(
                                              _vm._f("getCatalog")(
                                                _vm.viewDetail.tasks[0].toItem
                                                  .nodes
                                              )
                                            ) +
                                            " \n                         "
                                        )
                                      ]
                                    )
                                  : _c(
                                      "div",
                                      {
                                        staticClass: "backup-category-link",
                                        staticStyle: {
                                          lineHeight: "18Px",
                                          float: "left"
                                        },
                                        attrs: {
                                          title: _vm._f("getBackupInfo")(
                                            _vm._f("getCatalog")(
                                              _vm.viewDetail.tasks[0].toItem
                                                .nodes
                                            )
                                          )
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.openSource(
                                              _vm.viewDetail.tasks[0].toItem
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                             " +
                                            _vm._s(
                                              _vm._f("getBackupInfo")(
                                                _vm._f("getCatalog")(
                                                  _vm.viewDetail.tasks[0].toItem
                                                    .nodes
                                                )
                                              )
                                            ) +
                                            " \n                         "
                                        )
                                      ]
                                    )
                              ]),
                          _vm._v(" "),
                          _vm.viewDetail.tasks[0].tranferWay == "backup" ||
                          _vm.viewDetail.tasks[0].tranferWay == "retry-backup"
                            ? _c("div", [
                                _c("div", { staticClass: "log-line" }, [
                                  _c("div", { staticClass: "detail_txt" }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("language.common.to")) +
                                        ": "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "backup-category-link",
                                      staticStyle: {
                                        lineHeight: "18Px",
                                        float: "left"
                                      },
                                      attrs: {
                                        title: _vm._f("getCatalogTitle")(
                                          _vm._f("getCatalog")(
                                            _vm.viewDetail.tasks[0].toItem.nodes
                                          )
                                        )
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.toAimCatalog(
                                            _vm.viewDetail.tasks[0].toItem
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("getCatalog")(
                                            _vm.viewDetail.tasks[0].toItem.nodes
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ])
                              ])
                            : _c("div", [
                                _vm.viewDetail.tasks[0].lastLog.restoreInfo
                                  .restoreNew
                                  ? _c("div", { staticClass: "log-line" }, [
                                      _c("div", { staticClass: "detail_txt" }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("language.common.to")) +
                                            ": "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _vm.viewDetail.tasks[0].lastLog
                                        .restoreInfo
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "backup-category-link",
                                              staticStyle: {
                                                lineHeight: "18Px",
                                                float: "left"
                                              },
                                              attrs: {
                                                title: _vm._f(
                                                  "getCatalogTitle"
                                                )(
                                                  _vm._f("getCatalog")(
                                                    _vm.viewDetail.tasks[0]
                                                      .lastLog.restoreInfo
                                                      .toItems[0].nodes
                                                  )
                                                )
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.toAimCatalog(
                                                    _vm.viewDetail.tasks[0]
                                                      .lastLog.restoreInfo
                                                      .toItems[0]
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("getCatalog")(
                                                    _vm.viewDetail.tasks[0]
                                                      .lastLog.restoreInfo
                                                      .toItems[0].nodes
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ])
                                  : _c("div", { staticClass: "log-line" }, [
                                      !_vm.viewDetail.tasks[0].fromItem.data
                                        ? _c("div", [
                                            _c(
                                              "div",
                                              { staticClass: "detail_txt" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("language.common.to")
                                                  ) + ": "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "backup-category-link",
                                                staticStyle: {
                                                  lineHeight: "18Px",
                                                  float: "left"
                                                },
                                                attrs: { title: "Original" },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.toAimCatalog(
                                                      _vm.viewDetail.tasks[0]
                                                        .fromItem
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("Original")]
                                            )
                                          ])
                                        : _c("div", [
                                            _c(
                                              "div",
                                              { staticClass: "detail_txt" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("language.common.to")
                                                  ) + ": "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "backup-category-link",
                                                staticStyle: {
                                                  lineHeight: "18Px",
                                                  float: "left"
                                                },
                                                attrs: { title: "Original" },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.openRestoreAim(
                                                      _vm.viewDetail.tasks[0]
                                                        .fromItem
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("Original")]
                                            )
                                          ])
                                    ])
                              ])
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.nonFlag
                  ? _c("div", { staticClass: "detail_txt" }, [
                      _vm._v(_vm._s(_vm.$t("language.cloudSync.notRun")))
                    ])
                  : _c(
                      "div",
                      {
                        staticStyle: {
                          color: "#6f7886",
                          lineHeight: "18Px",
                          width: "100%",
                          height: "75Px",
                          marginBottom: "15Px"
                        }
                      },
                      [
                        _vm.showStatus(_vm.viewDetail.tasks[0]) == "failure"
                          ? _c("div", { staticClass: "log-line" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("language.common.result")) +
                                  ": " +
                                  _vm._s(_vm.$t("language.common.failure")) +
                                  "\n            "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showStatus(_vm.viewDetail.tasks[0]) == "patial"
                          ? _c("div", { staticClass: "log-line" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("language.common.result")) +
                                  ": " +
                                  _vm._s(_vm.$t("language.common.patial")) +
                                  "\n            "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showStatus(_vm.viewDetail.tasks[0]) == "success"
                          ? _c("div", { staticClass: "log-line" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("language.common.result")) +
                                  ": " +
                                  _vm._s(_vm.$t("language.common.success")) +
                                  "\n            "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showStatus(_vm.viewDetail.tasks[0]) == "cancel"
                          ? _c("div", { staticClass: "log-line" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("language.common.result")) +
                                  ": " +
                                  _vm._s(_vm.$t("language.common.canceled")) +
                                  "\n            "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.toItemExist
                          ? _c("span", [
                              _c("div", { staticClass: "log-line" }, [
                                _c(
                                  "div",
                                  { staticClass: "log-backupline-left" },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.$t("language.common.fileProcess")
                                        ) +
                                        ": " +
                                        _vm._s(
                                          _vm.viewDetail.tasks[0].lastLog
                                            .readyTranFileCount
                                        ) +
                                        "/" +
                                        _vm._s(
                                          _vm.viewDetail.tasks[0].lastLog
                                            .totalFileCount
                                        ) +
                                        "\n                        "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "log-line-right" }, [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t("language.common.dataProcess")
                                      ) +
                                      ":" +
                                      _vm._s(
                                        _vm._f("formatByte")(
                                          _vm.viewDetail.tasks[0].lastLog
                                            .fileTotalReadedBytes
                                        )
                                      ) +
                                      "/" +
                                      _vm._s(
                                        _vm._f("formatByte")(
                                          _vm.viewDetail.tasks[0].lastLog
                                            .totalBytes
                                        )
                                      ) +
                                      "        \n                         "
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "log-line" }, [
                                _c(
                                  "div",
                                  { staticClass: "log-backupline-left" },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.$t("language.common.startTime")
                                        ) +
                                        ": " +
                                        _vm._s(
                                          _vm._f("transferForMatTime")(
                                            _vm.viewDetail.tasks[0].lastLog
                                              .taskStartTime
                                          )
                                        ) +
                                        "\n                         "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "log-line-right" }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$t("language.common.endTime")
                                      ) +
                                      ": " +
                                      _vm._s(
                                        _vm._f("getEndTime")(
                                          _vm.viewDetail.tasks[0].lastLog
                                        )
                                      ) +
                                      "\n                         "
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "log-line" }, [
                                _c(
                                  "div",
                                  { staticClass: "log-backupline-left" },
                                  [
                                    _vm._v(
                                      "\n                           " +
                                        _vm._s(
                                          _vm.$t(
                                            "language.common.averageRateSpecial"
                                          )
                                        ) +
                                        ":"
                                    ),
                                    _c(
                                      "span",
                                      {
                                        attrs: {
                                          title: _vm.getAvgSpeed(
                                            _vm.viewDetail.tasks[0]
                                          )
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("formatByteSpeed")(
                                                _vm.viewDetail.tasks[0].lastLog
                                                  .fileTotalReadedBytes /
                                                  (_vm.viewDetail.tasks[0]
                                                    .lastLog
                                                    .taskElaspedTimeLong /
                                                    1000)
                                              )
                                            )
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ])
                          : _c(
                              "div",
                              {
                                staticStyle: {
                                  color: "#000",
                                  "font-size": "16Px",
                                  position: "relative",
                                  top: "20px"
                                }
                              },
                              [
                                _vm.errorReason == "backupInitConfigFail"
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                       " +
                                          _vm._s(
                                            _vm.$t(
                                              "language.cloudBackup.notFoundAim"
                                            )
                                          ) +
                                          "\n                       "
                                      )
                                    ])
                                  : _c("span", [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(
                                            _vm.$t(
                                              "language.cloudBackup.backupNotWork"
                                            )
                                          ) +
                                          "\n                       "
                                      )
                                    ])
                              ]
                            )
                      ]
                    ),
                _vm._v(" "),
                _vm.viewDetail.tasks[0].lastLog &&
                _vm.viewDetail.tasks[0].lastLog.errorList &&
                _vm.viewDetail.tasks[0].lastLog.errorList.length &&
                _vm.showStatus(_vm.viewDetail.tasks[0]) != "cancel"
                  ? _c("div", { staticClass: "log-line" }, [
                      _c(
                        "div",
                        {
                          staticClass: "log-backupline-left click-log-red",
                          on: {
                            click: function($event) {
                              return _vm.openFailedFiles()
                            }
                          }
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("language.common.viewFailed"))
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "retryBackUp",
                          staticStyle: { color: "#4a81ff" },
                          on: {
                            click: function($event) {
                              return _vm.retry()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("language.common.retryAll")))]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.showStatus(_vm.viewDetail.tasks[0]) == "failure" &&
                _vm.viewDetail.tasks[0].lastLog &&
                (!_vm.viewDetail.tasks[0].lastLog.errorList ||
                  !_vm.viewDetail.tasks[0].lastLog.errorList.length)
                  ? _c("div", { staticClass: "log-line" }, [
                      _c(
                        "div",
                        {
                          staticClass: "log-backupline-left click-log-red",
                          on: {
                            click: function($event) {
                              return _vm.openFailedFiles()
                            }
                          }
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("language.common.viewFailed"))
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "retryBackUp",
                          staticStyle: { color: "#4a81ff" },
                          on: {
                            click: function($event) {
                              return _vm.retry()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("language.common.retryAll")))]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.viewDetail.tasks[0].lastLog &&
                ((_vm.viewDetail.tasks[0].lastLog.errorList &&
                  _vm.viewDetail.tasks[0].lastLog.errorList.length) ||
                  (!_vm.viewDetail.tasks[0].lastLog.errorList.length ||
                    !_vm.viewDetail.tasks[0].lastLog.errorList)) &&
                !_vm.viewDetail.tasks[0].lastLog.error
                  ? _c(
                      "div",
                      {
                        staticClass: "log-line",
                        staticStyle: { color: "#6f7886" }
                      },
                      [
                        _vm.showStatus(_vm.viewDetail.tasks[0]) == "success"
                          ? _c(
                              "div",
                              {
                                staticClass: "log-backupline-left",
                                staticStyle: {
                                  position: "relative",
                                  "margin-top": "10Px"
                                }
                              },
                              [
                                _vm.viewDetail.tasks[0].tranferWay ==
                                  "backup" ||
                                _vm.viewDetail.tasks[0].tranferWay ==
                                  "retry-backup"
                                  ? _c("div", [
                                      _vm._v(
                                        "\n                               " +
                                          _vm._s(
                                            _vm.$t(
                                              "language.cloudBackup.successBck"
                                            )
                                          ) +
                                          "\n                               "
                                      )
                                    ])
                                  : _c("div", [
                                      _vm._v(
                                        "\n                                 " +
                                          _vm._s(
                                            _vm.$t(
                                              "language.cloudBackup.successRestore"
                                            )
                                          ) +
                                          "\n                               "
                                      )
                                    ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showStatus(_vm.viewDetail.tasks[0]) == "cancel"
                          ? _c(
                              "div",
                              {
                                staticClass: "log-backupline-left",
                                staticStyle: {
                                  position: "relative",
                                  "margin-top": "10Px"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                               " +
                                    _vm._s(
                                      _vm.$t(
                                        "language.cloudBackup.taskCanceled"
                                      )
                                    ) +
                                    "\n                          "
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  : _vm._e()
              ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74451906", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74451906","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/task_list_popups/view_backup_logs_popups.vue
// module id = null
// module chunks = 